/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { GridColumns } from '@mui/x-data-grid';
import { IconButton } from '@mui/material';
import { Edit } from '@mui/icons-material';
import EntityCondominium, { Condominium } from '../../entities/condominium.entity';
import { useCondominiumContext } from '../../contexts/CondominiumContext';
import { useCondominiums, useFetch } from '../../hooks';
import { Avatar, DataTable } from '../../components';
import MainContainer from '../../components/MainContainer';
import useStyles from './styles';

interface UpdateButtonProps {
  value: Condominium;
}

const UpdateButton = ({ value }: UpdateButtonProps): JSX.Element => {
  const { handleSelectCondominium } = useCondominiumContext();
  return (
    <IconButton onClick={() => handleSelectCondominium(value)}>
      <Edit />
    </IconButton>
  );
};

const headers: GridColumns = [
  {
    field: 'avatarUrl',
    headerName: '',
    disableColumnMenu: true,
    editable: false,
    disableExport: true,
    disableReorder: true,
    hideable: false,
    filterable: false,
    sortable: false,
    width: 62,
    align: 'center',
    hideSortIcons: true,
    renderCell: (value) => <Avatar src={value.row.avatarUrl} />,
  },
  { field: 'name', headerName: 'Nome', editable: false, flex: 1 },
  { field: 'bondCode', headerName: 'Vínculo', editable: false, flex: 1 },
  {
    field: 'city',
    headerName: 'Cidade',
    editable: false,
    flex: 1,
    valueGetter: (params) => params.row.fullAddress?.city,
  },
  {
    field: 'isDisabled',
    headerName: 'Status',
    editable: false,
    flex: 1,
    valueGetter: (params) => (params.row.isDisabled ? 'Desabilitado' : 'Habilitado'),
  },
  {
    field: 'action',
    headerName: 'Ações',
    disableColumnMenu: true,
    editable: false,
    disableExport: true,
    disableReorder: true,
    hideable: false,
    filterable: false,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    renderCell: (value) => <UpdateButton value={value.row} />,
    hideSortIcons: true,
  },
];

export const Condominiums = (): JSX.Element => {
  const styles = useStyles();
  const history = useNavigate();
  const repository = useCondominiums();
  const { data, loading } = useFetch(repository.fetchAll);
  const [condominiumList, setCondominiumList] = useState<EntityCondominium[]>([]);

  useEffect(() => {
    setCondominiumList(data ?? []);
  }, [data]);

  const handleCreate = useCallback(() => history('/condominiums/new'), [history]);

  if (loading) {
    return <></>;
  }

  return (
    <MainContainer>
      <div className={styles.content}>
        <DataTable
          columns={headers}
          rows={condominiumList || []}
          loading={loading}
          showAddButton
          onClickAdd={handleCreate}
        />
      </div>
    </MainContainer>
  );
};

export default Condominiums;


